<template>
	<div class="alert alert-info widget-block widget-block-logs">
		<div class="category">
			<multiselect
				v-model="category"
				:options="categoryList"
				:showLabels="false"			
				:allowEmpty="false"
				:maxHeight="200"
				:searchable="false"
				label="name"
				track-by="id"
				placeholder=""
				@input="OnSelectCategory"
				/>
		</div>

		<div v-if="valueList[category['id']]" v-show="category['id'] !== 'all'" class="value">
			<multiselect
				v-model="curValue"
				:options="valueList[category['id']]"
				:showLabels="false"
				:allowEmpty="false"
				:maxHeight="200"
				:searchable="false"
				label="name"
				track-by="id"
				placeholder=""
				@input="OnSelectValue"
				/>
		</div>
		
		<button class="btn-close-filter close" @click.stop="$emit('closeFilter')">×</button>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import Multiselect from 'vue-multiselect'
import Helper from '../../helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'filterLogs',
	//=========================================================================
	// свойства
	//=========================================================================
	props: ['name', 'value', 'list'],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			category: { id: 'all', name: this.localeFtc('main/list_all') },
			categoryList: [{
				'id': 'all',
				'name': this.localeFtc('main/list_all')
			}],
			valueList: {
				'all': []
			},
			curValue: null,
			// DOM-блок со списком
			$ulBlock1: null,
			$ulBlock2: null
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		let _cat = false

		// если задан список в виде объекта
		if (this.list && this.list['list'] && typeof this.list['list'] === 'object' && !Array.isArray(this.list['list']))
		{
			// формируем список категорий
			for (let _id in this.list['list'])
			{
				_cat = _id.split('/')[0]
				if (!this.valueList[_cat])
				{
					this.categoryList.push({
						'id': _cat,
						'name': Helper.localeFtc(_cat + '/title')
					})

					this.valueList[_cat] = []
					this.valueList[_cat].push({
						'id': _id,
						'name': this.localeFtc(this.list['list'][_id])
					})
				}
				else
				{
					this.valueList[_cat].push({
						'id': _id,
						'name': this.localeFtc(this.list['list'][_id])
					})
				}
			}
		}

		// если задано значение
		if (this.value)
		{
			this.curValue = {
				'id': this.value,
				'name': this.localeFtc(this.list['list'][this.value])
			}

			// получим и категорию
			_cat = this.value.split('/')[0]
			if (_cat !== null && _cat !== undefined && _cat !== '')
			{
				this.category = { id: _cat, name: Helper.localeFtc(_cat + '/title') }
			}
		}
	},
	//=========================================================================
	// компонент успешно примонтирован в DOM
	//=========================================================================
	mounted() {
		// если блок еще остался - удалим его
		if (this.$ulBlock1 && this.$ulBlock1.length) this.$ulBlock1.remove()
		if (this.$ulBlock2 && this.$ulBlock2.length) this.$ulBlock2.remove()

		// найдем врапер текущего поля
		let $component = $(this.$el)
		if (!$component.length) return

		// найдем блок со списком
		this.$ulBlock1 = $component.find('ul:first').parent()
		this.$ulBlock2 = $component.find('ul:last').parent()

		// пропишем жестко стиль блоку
		let _css = {
			'position': 'absolute',
			'top': '40px',
			'display': 'none',
			'width': 'calc(100% - 26px)',
			'z-index': 99
		}

		if (this.$ulBlock1.length)
		{
			this.$ulBlock1.css(_css)
			// переместим его наружу (в конец врапера)
			this.$ulBlock1.detach().appendTo($component)
		}

		if (this.$ulBlock2.length)
		{
			this.$ulBlock2.css(_css)
			// переместим его наружу (в конец врапера)
			this.$ulBlock2.detach().appendTo($component)
		}
	},
	//=========================================================================
	// наблюдение за значением
	//=========================================================================
	watch: {
		'value': function(newValue) {
			// если значение не установлено (обнулили)
			if (!newValue)
			{
				this.$nextTick(() => {
					// категория "Все"
					this.category = { id: 'all', name: this.localeFtc('main/list_all') }
					// значения нет
					this.curValue = null
				})

				return
			}

			this.curValue = { id: newValue, name: this.localeFtc(this.list['list'][newValue]) }

			// получим и категорию
			let _cat = newValue.split('/')[0]
			if (_cat !== null && _cat !== undefined && _cat !== '')
			{
				this.category = { id: _cat, name: Helper.localeFtc(_cat + '/title') }
			}
		}
	},
	//=========================================================================
	// меотоды
	//=========================================================================
	methods: {
		// выбрали категорию
		OnSelectCategory(e) {
			// поменяли категорию на выбранную
			this.category = { id: e.id, name: e.name }

			// устанавливаем значение в первый элемент
			this.curValue = null
			if (e.id !== 'all')
			{
				this.curValue = { id: this.valueList[e.id][0]['id'], name: this.localeFtc(this.valueList[e.id][0]['name']) }
			}

			// сообщаем значение
			this.$emit('input', this.curValue ? this.curValue['id'] : false)
		},
		// выбрали значение
		OnSelectValue(e) {
			// получили значение
			this.curValue = { id: e.id, name: e.name }

			// сообщаем значение
			this.$emit('input', e.id)
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: { Multiselect }

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
div.widget-block {
	display: inline-flex;
	font-size: 12px;
	padding: 3px 18px 4px 8px;
}

@media screen and (max-width: 767px) {
	div.widget-block {
		display: block;
		margin-bottom: 20px;
		width: 100%;
	}
}

</style>



// WEBPACK FOOTER //
// filterLogs.vue?0617d509